import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { generateToken } from "../shared/utils/GenerateTokenFirebase";
import socket from "../shared/utils/Socket"; // adjust the path
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import GlobalButton from "../shared/utils/GlobalButton";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await axios.post(`${serverURL}/api/auth/login`, {
        email,
        password,
      });

      if (response?.data?.success) {
        const { token, role, userId, emailId, name, superAdminEmail } =
          response.data;
        socket.on("connect", () => {
          // console.log("✅ Socket connected:", socket.id);
        });
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        localStorage.setItem("userId", userId);
        localStorage.setItem("email", emailId);
        localStorage.setItem("name", name);
        localStorage.setItem("superAdminEmail", superAdminEmail);
        const fireBaseToken = await generateToken();
        if (role == -1) navigate("/adminportal/dashboard");
        else if (role == 0) navigate("/adminportal/Enquiry");
        else if (role == 3) navigate("/adminportal/vendorDetails");
        else if (role == 4) navigate("/adminportal/Campaign");
        else if (role == 6) {
          navigate("/adminportal/locationsVerification");
        } else if (role == 7) {
          navigate("/adminportal/campaign");
        } else navigate("/adminportal/vendorDetails");
        if (fireBaseToken) {
          const response2 = await axios.put(
            `${serverURL}/api/auth/edit/${userId}`,
            {
              fireBaseToken,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        text:
          err?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center w-full h-screen bg-gray-100 ">
      <div className="flex w-full h-full bg-white shadow-lg  overflow-hidden">
        {/* Left Side - Login Form */}
        <div className=" w-full md:w-1/2 flex flex-col justify-center p-12">
          <div className="flex justify-center mb-6">
            <img
              src="/assests/images/pixell dark.png"
              alt="Logo"
              className="h-10"
            />
          </div>
          <h2 className="text-xl md:text-3xl font-bold text-center mb-6">
            Sign in to your account
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-600">Your email</label>
              <input
                type="email"
                className="w-full p-3 mt-2 border rounded"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-4 relative">
              <label className="block text-gray-600">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="w-full p-3 mt-2 border rounded pr-10"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  tabIndex={-1}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </button>
              </div>
            </div>

            <GlobalButton
              type="submit"
              variant="primary"
              size="large"
              isLoading={isLoading}
            >
              Sign in
            </GlobalButton>
            <p className="text-center text-gray-500 text-sm mt-4">
              Don't have an account?{" "}
              <a href="/" className="text-blue-500 hover:underline">
                Go to Website
              </a>
            </p>
          </form>
        </div>

        {/* Right Side - Image with Full Height */}
        <div
          className="w-1/2 hidden md:block h-full bg-cover bg-center flex items-center justify-center"
          style={{
            backgroundImage: "url('/assests/AdminDashboard/Login-banner.jpg')",
          }}
        >
          <div className="bg-blue-900 bg-opacity-70 text-white p-16 shadow-lg h-full w-full text-start">
            <h2
              className="text-3xl font-bold my-6"
              style={{
                width: "28rem",
                lineHeight: "inherit",
                letterSpacing: "1px",
              }}
            >
              Transforming Local Advertising with Seamless Signage Solutions
            </h2>
            <ul className="space-y-4 text-lg">
              <li>
                ✅ Connect with trusted hyperlocal signage vendors effortlessly.
              </li>
              <li>
                ✅ Ensure agility, visibility, and quality in every campaign.
              </li>
              <li>✅ Manage and monitor your signage network with ease.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
